// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// router的配置
import './permission'
// 引入element-ui插件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// swiper的css
import 'swiper/dist/css/swiper.css'
// 引入vuex配置
import store from './store'
// 全局引入工具类
import Utils from '@/utils/utils.js'
// 全局常量
import Constant from '@/api/constant.js'
// ajax
import request from '@/utils/request'

import Breadcrumb from '@/components/commonBreadcrumb'

// Vant-UI
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)


//0318 大彤彤加
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {ak: 'Trw6J0YWMmqmPcYGOYUTYNruGSOoA8Vx'})
import vueTouch from 'kim-vue-touch'
Vue.use(vueTouch)


Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.use(Breadcrumb)

Vue.prototype.$utils = Utils
Vue.prototype.$axios = request
Vue.prototype.$constant = Constant

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js